import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampCollegeIcon: React.FC<SVGComponentProps> = ({
  width = 16,
  height = 16
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_bootcamp_college)">
        <path
          d="M1.33203 14.6667H14.6654"
          stroke="#62748E"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M11.9987 6H9.33203C7.67736 6 7.33203 6.34533 7.33203 8V14.6667H13.9987V8C13.9987 6.34533 13.6534 6 11.9987 6Z"
          stroke="#62748E"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M10 14.6667H2V3.33337C2 1.67871 2.34533 1.33337 4 1.33337H8C9.65467 1.33337 10 1.67871 10 3.33337V6.00004"
          stroke="#62748E"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M2 4H4M2 6.66667H4M2 9.33333H4M10 8.66667H11.3333M10 10.6667H11.3333"
          stroke="#62748E"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M10.6641 14.6667V12.6667"
          stroke="#62748E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_bootcamp_college">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { BootcampCollegeIcon };
